module.exports = fox._r("images/logos/logo_64264.png", __webpack_public_path__ + "_/_/_/common/frame/images/logos/logo_64264.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos/logo_64264.png
// module id = 321
// module chunks = 2